export default __webpack_public_path__ + "static/Market-launch-660769e9142a9fe578d7ae2154e148ff.webp";